/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_EmployeesInputs */

const es_tools_legajox_employees = /** @type {(inputs: Tools_Legajox_EmployeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando empleados en Legajox...`)
};

const en_tools_legajox_employees = /** @type {(inputs: Tools_Legajox_EmployeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox employees...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox employees..." |
*
* @param {Tools_Legajox_EmployeesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_employees = /** @type {((inputs?: Tools_Legajox_EmployeesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_EmployeesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_employees(inputs)
	return en_tools_legajox_employees(inputs)
});
export { tools_legajox_employees as "tools.legajox.employees" }